import gql from "graphql-tag";

const removeBar = gql`
  mutation removeBar($id: ID!) {
    removeBar(id: $id) {
      _id
    }
  }
`;

export default removeBar;
